import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus";
import submittingRequestStatus from "./submittingRequestStatusAction";
import * as API from "../utils/apiPath";

export function loadHomePageDataSuccess(homePageData) {
  return { type: types.LOAD_HOME_PAGE_DATA_SUCCESS, homePageData };
}

export function loadFaqDataSuccess(faqData) {
  return { type: types.LOAD_FAQ_DATA_SUCCESS, faqData };
}

export function loadLeaderDataSuccess(leaders) {
  return { type: types.LOAD_LEADER_DATA_SUCCESS, leaders };
}

export function loadTestimonialsDataSuccess(testimonials) {
  return { type: types.LOAD_TESTIMONIALS_DATA_SUCCESS, testimonials };
}

export function loadCommunitiesDataSuccess(community) {
  return { type: types.LOAD_COMMUNITY_DATA_SUCCESS, community };
}

export function loadTeamsDataSuccess(teams) {
  return { type: types.LOAD_TEAMS_DATA_SUCCESS, teams };
}

export function loadAdvisorsDataSuccess(advisors) {
  return { type: types.LOAD_ADVISORS_DATA_SUCCESS, advisors };
}
const submitSubscriptionEmail = async (dispatch, params) => {
  dispatch(submittingRequestStatus(true));
  try {
    const response = await agent.post(API.SAVESUBSCRIBTIONEMAIL, params);

    if (response?.status === 200) {
      dispatch(submittingRequestStatus(false));
    }
  } catch (error) {
    dispatch(submittingRequestStatus(false));
    throw error;
  }
};


export function sendEmailForVerification(params) {
  return async function (dispatch) {
    try {
      dispatch(submittingRequestStatus(true));

      const response = await agent.post(API.SEND_EMAIL_FOR_VERIFICATION, params);

      dispatch(submittingRequestStatus(false));

      // ✅ Return structured response
      return {
        status: response?.status || response?.data?.status,
        message: response?.data?.message || "Verification email sent successfully.",
      };
    } catch (error) {
      dispatch(submittingRequestStatus(false));
      return {
        status: error?.response?.status || 500,
        message:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong. Please try again later.",
      };
    }
  };
}


export function loadHomePageData(id) {
  return async function (dispatch) {
    dispatch(loadHomePageDataSuccess(''));
    dispatch(toggleNetworkRequestStatus(true));
    await agent
      .get(API.CMS_PAGE + id)
      .then((response) => {
        dispatch(toggleNetworkRequestStatus(false));
        if (response?.status === 200 || response?.status === 201) {
          if (response?.data?.status === 200) {
            dispatch(loadHomePageDataSuccess(response?.data?.data));
            loadAdvisorsData()(dispatch);
            loadTeamsData()(dispatch);
          }
        }
      })
      .catch((error) => {
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      });
  };
}

export function loadFaqData(params) {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    await agent
      .get(API.FAQ_PAGE, { params: params })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(loadFaqDataSuccess(response.data.data));
          }
          dispatch(toggleNetworkRequestStatus(false));
        }
      })
      .catch((error) => {
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      });
  };
}

export function sendContactUs(params) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));

    try {
      const result = await agent.post(API.CONTACT_US_PAGE, params);

      dispatch(submittingRequestStatus(false));
      return result; // <-- now it's valid
    } catch (error) {
      dispatch(submittingRequestStatus(false));
      throw error;
    }
  };
}


export function loadLeaderData(id) {
  return async function (dispatch) {
    await agent
      .get(API.LEADER_DATA, { params: { limit: id } })
      .then((response) => {
        dispatch(loadLeaderDataSuccess(response?.data?.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadTestimonialsData(id) {
  return async function (dispatch) {
    await agent
      .get(API.TESTIMONIALS_DATA, { params: { limit: id } })
      .then((response) => {
        dispatch(loadTestimonialsDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadCommunityData(id) {
  return async function (dispatch) {
    await agent
      .get(API.COMMUNITY_DATA, { params: { limit: id } })
      .then((response) => {
        dispatch(loadCommunitiesDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export const sendActivationMail = (params) => {
  return async function (dispatch) {
    return submitSubscriptionEmail(dispatch, params);
  };
};

export const saveSubscribtionMail = sendActivationMail;

export function loadAdvisorsData() {
  return async function (dispatch) {
    await agent
      .get(API.ABOUTUS_DATA + "/Advisor", {})
      .then((response) => {
        dispatch(loadAdvisorsDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadTeamsData() {
  return async function (dispatch) {
    await agent
      .get(API.ABOUTUS_DATA + "/Team", {})
      .then((response) => {
        dispatch(loadTeamsDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}